import { map, share } from 'rxjs/operators';
import { LocalStorageDataStream, messaging } from '@pendo/services/Communication';
import { useThemesStore } from '@/stores/themes.store';
import { useLayoutsStore } from '@/stores/layouts.store';

const { messageChannels, messageType } = messaging;

export function listenToDesigner (_store) {
    const localStorageDataStream = new LocalStorageDataStream('localStorage', 'pendo', false);
    localStorageDataStream.listen();
    const appEngineMessage$ = localStorageDataStream.getMessagesForChannel$(messageChannels.APPENGINE).pipe(
        map((envelope) => envelope.message),
        share(),
    );

    appEngineMessage$.subscribe((message) => {
        if (message.type === messageType.RELOAD_LAYOUTS) {
            useLayoutsStore().loadAll({ reFetch: true });
        } else if (message.type === messageType.RELOAD_THEMES) {
            useThemesStore().loadAll({ reFetch: true });
        }
    });
}
